import { useId } from 'react';

export function useSearchComboboxA11y(): {
    searchInputHintId: string;
    mobileSearchInputHintId: string;
} {
    const searchInputHintId = useId();
    const mobileSearchInputHintId = useId();

    return {
        searchInputHintId,
        mobileSearchInputHintId,
    };
}
